import React from 'react'

const useRole = () => {
  const userRole = localStorage.getItem('user.role') || ""
  return userRole
}

export default useRole
